import Promise from 'bluebird';
import { CustomerUtils } from '@bingads-webui-clientcenter/entity-utils';

/**
 * CustomerProfileModel holds a list profile properties for a customer.
 * @typedef {object} CustomerProfileModel
 * @property {number} [numberOfBillToInvoiceAccounts]
 * @property {number} [numberOfBillToPrepayAccounts]
 * @property {number} [numberOfBillToThresholdAccounts]
 * @property {bool} [isOptedInConsolidatedBilling]
 * @property {bool} [isOptedInCampaignDetails]
 * @property {number} [totalNumberOfBillToAccounts]
 */

/**
 * Get customer profile on given actions by calling /API/Customer/Profile
 * @param {object} jsDataCcRest jsData object
 * @param {String|Number} customerId The customer id
 * @returns {Promise<CustomerProfileModel>} An object with { actionName : value } where value is a boolean indication if the actionName is authorized or not
 */
export const getCustomerProfile = (jsDataCcRest, customerId) => {
  if (parseInt(customerId, 10) >= 0) {
    return jsDataCcRest.CustomerProfile.find(customerId)
      .then(customerProfile => CustomerUtils.parseCustomerProfile(customerProfile));
  }

  return Promise.resolve(null);
};
